import { storeAnswer } from '../../services/manager';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';
import SessionScreen from './SessionScreen';
import VideoPlayer from '../../components/VideoPlayer'
import { useEffect } from 'react';

export type StoredValue = string;

export default function Screen(props: WrapperScreenProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  async function answer(doIntro: String) {
    await storeAnswer('84', t('screens:84.uuid'), doIntro as StoredValue);
    navigate('/session/rotate-instruction', { replace: true });
  }

  // async function goBack() {
  //   navigate(-1);
  // }

  useEffect(() => {
    props.useAudio('');
  });

  const actions = (<>
    {/* <Button label={t('go_back')} variant="secondary" onClick={() => goBack()} /> */}
    <Button label={t('continue')} variant="primary" onClick={() => answer('true')} />
  </>);

  return (
    <SessionScreen
      screen="84"
      title={`${t('screens:84.step')} ${t('screens:84.title')}`}
      chapter={3}
      progress={0}
      actions={actions}
    >
      <VideoPlayer src={t('screens:84.source')} poster={t('screens:84.poster')} />
    </SessionScreen>
  );
};
